export enum ACTIVE_BREAKPOINT {
  isMobile = "Mobile",
  isTablet = "Tablet",
  isDesktop = "Desktop",
}
